<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            text
            x-small
            :disabled="submittingForm"
            @click="$router.push({ name: 'disciplinas' })"
          >
            <v-icon left>fa fa-angle-left</v-icon>
          </v-btn>

          {{ editing ? "Editando" : "Criando" }} Componente Curricular
        </h1>
      </v-col>
    </v-row>

    <ValidationObserver v-slot="{ handleSubmit }">
      <form :disabled="submittingForm" @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="4" class="pt-0 pb-0">
            <ValidationProvider name="Código" rules="required" v-slot="{ errors }">
              <e-label>Código</e-label>
              <v-text-field
                v-model="form.codigo"
                :error-messages="[...errors, ...(apiErrors.codigo || [])]"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>

          <v-col cols="8" class="pt-0 pb-0">
            <ValidationProvider name="Descrição" rules="required" v-slot="{ errors }">
              <e-label>Descrição</e-label>
              <v-text-field
                v-model="form.descricao"
                :error-messages="[...errors, ...(apiErrors.descricao || [])]"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>

          <v-col cols="12" class="pt-0 pb-0">
            <ValidationProvider name="Área de Conhecimento" v-slot="{ errors }">
              <e-label>Área de Conhecimento</e-label>
              <v-select
                v-model="form.area_conhecimento_id"
                :items="areasDeConhecimentoList"
                :error-messages="[...errors, ...(apiErrors.area_conhecimento_id || [])]"
                :loading="loadingAreas"
                :disabled="loadingAreas"
                item-text="descricao"
                item-value="id"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>

          <v-col cols="12">
            <v-btn
              block
              color="primary"
              type="submit"
              :disabled="submittingForm"
              :loading="submittingForm"
            >
              Enviar Dados
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },

  props: {
    editing: {
      default: false,
      type: Boolean,
    },
  },

  data() {
    return {
      apiErrors: {},
      areasDeConhecimentoList: [],
      form: {
        area_conhecimento_id: null,
        codigo: "",
        descricao: "",
      },
      loadingAreas: false,
      submittingForm: false,
    };
  },

  computed: {
    ...mapGetters("Disciplinas", ["carregandoDisciplinas", "disciplinas", "disciplinasList"]),
  },

  mounted() {
    this.loadData();
  },

  methods: {
    ...mapActions("Disciplinas", ["loadDisciplinas"]),

    async loadAreasDeConhecimento() {
      this.loadingAreas = true;
      try {
        this.areasDeConhecimentoList =
          await this.$services.disciplinasService.listarAreasDeConhecimento();
      } catch (error) {
        this.$handleError(error);
      }
      this.loadingAreas = false;
    },

    async loadData() {
      try {
        if (this.disciplinas.length === 0) {
          this.$loaderService.open("Carregando dados");
        }
        await Promise.all([this.loadAreasDeConhecimento(), this.loadDisciplinas()]);
        if (this.editing) {
          const { disciplina_id } = this.$route.params;
          const disciplina = this.disciplinas.get(parseInt(disciplina_id, 10));
          if (disciplina) {
            this.form.area_conhecimento_id = disciplina?.area_conhecimento?.id ?? null;
            this.form.codigo = disciplina.codigo ?? "";
            this.form.descricao = disciplina.descricao ?? "";
            this.form.id = disciplina.id ?? null;
          }
        }
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      }
    },

    async submitForm() {
      this.submittingForm = true;
      this.apiErrors = {};
      try {
        if (this.editing) {
          await this.$services.disciplinasService.atualizarDisciplina(this.form);
        } else {
          await this.$services.disciplinasService.criarDisciplina(this.form);
        }
        this.$toast.success("Componente Curricular Atualizado com sucesso");
        this.$router.push({ name: "disciplinas" });
      } catch (error) {
        if (error.errors) {
          const errors = error.errors;

          Object.keys(errors).forEach((key) => {
            this.apiErrors[key] = Array.isArray(errors[key]) ? errors[key] : [errors[key]];
          });
        } else if (error.response?.data?.error?.message) {
          this.$toast.danger(error.response.data.error.message);
        } else {
          this.$handleError(error);
        }
      } finally {
        this.submittingForm = false;
      }
    },
  },

  watch: {
    "form.codigo": function () {
      delete this.apiErrors.codigo;
    },
    "form.descricao": function () {
      delete this.apiErrors.descricao;
    },
  },
};
</script>

<style></style>
